export const BASE_URL = '/api/v1/';

export const LOGIN_ENDPOINT                             = BASE_URL + 'login';
export const LOGOUT_ENDPOINT                            = BASE_URL + 'logout';
export const REFRESH_TOKEN_ENDPOINT                     = BASE_URL + 'session/refresh';
export const GET_ADMIN_USER_ENDPOINT                    = BASE_URL + 'getuser';
export const TOS_LINK_ENDPOINT                          = BASE_URL + 'tosLink';

export const MODULES_ENDPOINT                           = BASE_URL + 'modules';
export const MARKETING_MODULES_ENDPOINT                 = BASE_URL + 'marketing/modules';
export const MARKETING_COURSE_EVENT_SEARCH_ENDPOINT     = BASE_URL + 'marketing/search';
export const ADD_MARKETING_LIST_ITEM_ENDPOINT           = BASE_URL + 'marketing/add-item';
export const GET_MARKETING_LIST_ITEMS_ENDPOINT          = BASE_URL + 'marketing/list-items';
export const REORDER_MARKETING_LIST_ITEMS_ENDPOINT      = BASE_URL + 'marketing/reorder';
export const REMOVE_MARKETING_LIST_ITEM_ENDPOINT        = BASE_URL + 'marketing/remove'

export const GET_ONE_COURSE_ENDPOINT                    = BASE_URL + 'public/courses/${id}';
export const ADMIN_COURSES_OVERVIEW_ENDPOINT            = BASE_URL + 'admin/courses';
export const ADMIN_ALL_COURSES_ENDPOINT                 = BASE_URL + 'admin/courses';
export const ALL_COURSES_ENDPOINT                       = BASE_URL + 'courses';
export const ALL_COURSES_AND_ELEARNING_ENDPOINT         = BASE_URL + 'courses-with-elearning';
export const ADMIN_CREATE_COURSE_ENDPOINT               = BASE_URL + 'admin/courses';
export const ADMIN_CREATE_ELEARNING_COURSE_ENDPOINT     = BASE_URL + 'admin/elearning-courses';
export const ADMIN_UPDATE_COURSE_ENDPOINT               = BASE_URL + 'admin/courses/${id}';
export const ADMIN_UPDATE_ELEARNING_COURSE_ENDPOINT     = BASE_URL + 'admin/elearning-courses/${id}';
export const ADMIN_DELETE_COURSE_ENDPOINT               = BASE_URL + 'admin/courses/${id}';
export const GET_ALL_ELEARNING_ENDPOINT                 = BASE_URL + 'admin/elearning';

export const COURSE_TESTIMONIALS                = BASE_URL + 'courses/${courseId}/testimonials';
export const CREATE_TESTIMONIAL                 = BASE_URL + 'testimonials';
export const UPDATE_TESTIMONIAL                 = BASE_URL + 'testimonials/${id}';
export const DELETE_TESTIMONIAL                 = BASE_URL + 'testimonials/${id}';

export const ALL_VENUES_ENDPOINT                = BASE_URL + 'venues';
export const CREATE_VENUE_ENDPOINT              = BASE_URL + 'venues';
export const UPDATE_VENUE_ENDPOINT              = BASE_URL + 'venues/${id}';
export const DELETE_VENUE_ENDPOINT              = BASE_URL + 'venues/${id}';

export const ALL_PRESENTERS_ENDPOINT            = BASE_URL + 'presenters';
export const CREATE_PRESENTER_ENDPOINT          = BASE_URL + 'presenters';
export const UPDATE_PRESENTER_ENDPOINT          = BASE_URL + 'presenters/${id}';
export const DELETE_PRESENTER_ENDPOINT          = BASE_URL + 'presenters/${id}';
export const PRESENTER_PICTURE_ENDPOINT         = BASE_URL + 'presenters/${id}/picture';
export const UPLOAD_PRESENTER_PICTURE           = BASE_URL + 'presenters/${id}/picture';
export const DELETE_PRESENTER_PICTURE_ENDPOINT  = BASE_URL + 'presenters/${id}/picture';
export const GET_PRESENTER_SEARCH_RESULTS       = BASE_URL + 'presenters/search';

export const ALL_TIMETABLES_ENDPOINT            = BASE_URL + 'timetables';
export const CREATE_TIMETABLE_ENDPOINT          = BASE_URL + 'timetables';
export const UPDATE_TIMETABLE_ENDPOINT          = BASE_URL + 'timetables/${id}';
export const DELETE_TIMETABLE_ENDPOINT          = BASE_URL + 'timetables/${id}';

export const ALL_PUBLIC_EVENTS_ENDPOINT                     = BASE_URL + 'public/events';
export const ALL_FEATURED_EVENTS_ENDPOINT                   = BASE_URL + 'public/featured/events'
export const ONE_EVENT_ENDPOINT                             = BASE_URL + 'public/events/${id}';
export const ALL_EVENTS_ENDPOINT                            = BASE_URL + 'events';
export const CREATE_EVENT_ENDPOINT                          = BASE_URL + 'events';
export const UPDATE_EVENT_ENDPOINT                          = BASE_URL + 'events/${id}';
export const DELETE_EVENT_ENDPOINT                          = BASE_URL + 'events/${id}';
export const EVENT_WEBSITE_DISPLAY_AVAILABLE_POSITIONS      = BASE_URL + 'events/website/available-positions'
export const UPDATE_WEBSITE_DISPLAY_POSITION                = BASE_URL + 'events/website-display/${id}';

export const GET_ALL_BOOKINGS_ENDPOINT              = BASE_URL + 'bookings';
export const UPDATE_BOOKING_ENDPOINT                = BASE_URL + 'bookings/${id}';
export const DELETE_BOOKING_ENDPOINT                = BASE_URL + 'bookings/${id}';
export const POST_BOOKING_ENROLL_USERS_ENDPOINT     = BASE_URL + 'booking/enroll-users';
export const VALIDATE_BOOKING_ORGANISATION_ENDPOINT = BASE_URL + 'booking/validate-organisation';
export const VALIDATE_BOOKING_DELEGATE_ENDPOINT     = BASE_URL + 'booking/validate-delegate';
export const VALIDATE_BOOKING_PAYMENT_ENDPOINT      = BASE_URL + 'booking/validate-payment';
export const PROCESS_BOOKING_ENDPOINT               = BASE_URL + 'booking/process';
export const GET_BOOKING_COUNTRIES_ENDPOINT         = BASE_URL + 'booking/countries';
export const GET_BOOKING_COUNTRY_ENDPOINT           = BASE_URL + 'booking/country';
export const BOOKING_STATS_ENDPOINT                 = BASE_URL + 'booking-stats';

export const CREATE_RESOURCE_PACK_ENDPOINT          = BASE_URL + 'packs';
export const UPDATE_RESOURCE_PACK_ENDPOINT          = BASE_URL + 'packs/${id}?_method=PUT';
export const ALL_RESOURCE_PACKS_ENDPOINT            = BASE_URL + 'packs';
export const DELETE_RESOURCE_PACK_ENDPOINT          = BASE_URL + 'packs/${id}';
export const GET_RESOURCE_PACK_BY_CODE_ENDPOINT     = BASE_URL + 'public/packs?code=${code}';
export const GET_RESOURSE_PACK_SEARCH_RESULTS       = BASE_URL + 'packs/search';

export const CHECK_PROMO_CODE_ENDPOINT              = BASE_URL + 'promos/check';
export const GET_ALL_PROMO_CODES_ENDPOINT           = BASE_URL + 'promos';
export const CREATE_PROMO_CODE_ENDPOINT             = BASE_URL + 'promos';
export const DELETE_PROMO_CODE_ENDPOINT             = BASE_URL + 'promos/${id}';
export const UPDATE_PROMOTION_ENDPOINT              = BASE_URL + 'promos/${id}';

export const DELETE_ATTENDEE_ENDPOINT               = BASE_URL + 'attendees/${id}';
export const ADD_ATTENDEE_ENDPOINT                  = BASE_URL + 'events/${eventId}/attendees';
export const UPDATE_ATTENDEE_ENDPOINT               = BASE_URL + 'attendees/${id}';
export const UPDATE_ATTENDEES_ENDPOINT              = BASE_URL + 'attendees';

export const GET_STATS_ENDPOINT                     = BASE_URL + 'stats';
export const GET_REFERRAL_STATS_ENDPOINT            = GET_STATS_ENDPOINT + '/referrals';

export const DELETE_TRANSACTION_DELEGATE_ENDPOINT   = BASE_URL + 'transaction-delegates/${delegateId}';

export const GET_AD_ENDPOINT = BASE_URL + 'marketing-ad/get';
export const UPDATE_AD_ENDPOINT = BASE_URL + 'marketing-ad/update';

const replaceTemplatePlaceholder = (placeholderName, replacementText, templateText) => {

    var replaceTarget   = '${' + placeholderName + '}';

    return templateText.replace(replaceTarget, replacementText);
};

export const generateEndpoint = (endpointTemplate, params) => {

    var renderedTemplate = endpointTemplate;

    for (let key in params) {

        if (params.hasOwnProperty(key)) {

            renderedTemplate = replaceTemplatePlaceholder(key, params[key], renderedTemplate);
        }
    }

    return renderedTemplate;
};


// WEBPACK FOOTER //
// ./services/endpoints.js